import React from "react";
import { FormattedMessage } from "react-intl";

interface Props {
  labelText: string;
  code?: string;
  clickHandler: (selected: string) => any;
  buttonEnabled: boolean;
}

const stylesSelected = {
  backgroundColor: "#ebdcc4",
  color: "#000000",
  border: '1px solid #ebdcc6',
  borderRadius: '6px',
  boxShadow: 'none',
  padding: "8px",
  textDecoration: "bold",
  display: "inline-block",
  fontSize: "16px",
  outline: 'none'
}

const stylesNotSelected = {
  backgroundColor: "#ffffff",
  color: "#000000",
  border: '1px solid #ebdcc6',
  borderRadius: '6px',
  boxShadow: 'none',
  padding: "8px",
  textDecoration: "bold",
  display: "inline-block",
  fontSize: "16px",
  outline: 'none'
}


const PrimaryButton: React.FC<Props> = ({ labelText, code, clickHandler, buttonEnabled }) => {
  return (
    <button className="main-btn" style={buttonEnabled ? stylesSelected : stylesNotSelected} onClick={() => clickHandler(code || '')}><FormattedMessage id={labelText} /></button>
  );
};

export default PrimaryButton;
